export const qa = 'additional-service-card-airwallex';
